export function searchCollections(term) {
  this.setState({ collectionsSearchTerm: term });
}
